import React from 'react';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';


interface IVideoPlayerProps {
  options: videojs.PlayerOptions;
}

const initialOptions: videojs.PlayerOptions = {
  controls: true,
  fluid: true,
  controlBar: {
    volumePanel: {
      inline: false
    }
  }
};

export const VideoPlayer: React.FC<IVideoPlayerProps> = React.memo(({options}) => {
  const videoRef = React.useRef<HTMLVideoElement>(null);
  const playerRef = React.useRef<videojs.Player | null>(null);

  React.useEffect(() => {

    // Make sure Video.js player is only initialized once
    if (!playerRef.current && videoRef.current) {
      videojs.log("Initializing Video.js player");
      const player = playerRef.current = videojs(videoRef.current, {...initialOptions, ...options}, () => {
        videojs.log('player is ready');
      });

    } else if (playerRef.current) {
      console.log('playerRef.current', playerRef.current);
      const player = playerRef.current;

      if (options.autoplay !== undefined) {
        player.autoplay(options.autoplay);
      }
    }

    return () => {
      // console.log("We are disposing the video player");
      // const player = playerRef.current
      // if (player && !player.isDisposed()) {
      //   console.log("We are removing the event listeners");
      //   if (playerRef.current) {
      //     playerRef.current.off('ended');
      //     playerRef.current.off('timeupdate');
      //   }
      //   player.dispose();
      //   playerRef.current = null;
      //   playerRef.current = null
      // }
    };
  }, [options]);

  console.log("We are adding a new video element to the page " + videoRef.current);

  return (
    <div data-vjs-player>
      <video ref={videoRef} className="video-js" key={options.src}/>
    </div>
  );
});

export default VideoPlayer;

